import React, { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

const KEY = "sn_cookie_consent";

export function getConsent() {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
}

export function CookieConsent() {
  const [show, setShow] = useState(false);
  const [custom, setCustom] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: true, preferences: true });

  useEffect(() => { if (!getConsent()) setShow(true); }, []);

  const save = (choice) => {
    const consent = { essential: true, analytics: choice.analytics, preferences: choice.preferences, ts: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(consent));
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/privacy/consent`, {
      method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include",
      body: JSON.stringify(consent),
    }).catch(() => {});
    window.dispatchEvent(new Event("sn-consent"));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[90] p-3 sm:p-4" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto bg-white border border-border rounded-2xl shadow-2xl p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <span className="h-9 w-9 rounded-xl bg-[#111] text-white grid place-items-center shrink-0"><Cookie size={18} /></span>
          <div className="min-w-0 flex-1">
            <div className="font-display font-bold text-ink">We value your privacy</div>
            <p className="text-xs text-muted-foreground mt-1">
              We use essential cookies to run SHOP NOW, and — with your consent — analytics & preference cookies to improve your experience.
              You can accept, reject non-essential, or customise. See our <a href="/legal?tab=data-protection" className="text-emerald font-semibold">Data Protection</a> policy.
            </p>

            {custom && (
              <div className="mt-3 space-y-2" data-testid="cookie-customise">
                <label className="flex items-center justify-between text-sm bg-secondary/50 rounded-lg px-3 py-2">
                  <span><b>Essential</b> — required for the site to work</span>
                  <span className="text-xs font-semibold text-muted-foreground">Always on</span>
                </label>
                <label className="flex items-center justify-between text-sm rounded-lg px-3 py-2 border border-border cursor-pointer">
                  <span><b>Analytics</b> — anonymous usage & traffic</span>
                  <input type="checkbox" checked={prefs.analytics} onChange={(e) => setPrefs({ ...prefs, analytics: e.target.checked })} data-testid="cookie-analytics-toggle" />
                </label>
                <label className="flex items-center justify-between text-sm rounded-lg px-3 py-2 border border-border cursor-pointer">
                  <span><b>Preferences</b> — remember your choices</span>
                  <input type="checkbox" checked={prefs.preferences} onChange={(e) => setPrefs({ ...prefs, preferences: e.target.checked })} data-testid="cookie-preferences-toggle" />
                </label>
              </div>
            )}

            <div className="flex flex-wrap gap-2 mt-3">
              <button onClick={() => save({ analytics: true, preferences: true })} className="bg-emerald text-white rounded-full px-4 py-2 text-sm font-bold" data-testid="cookie-accept-all">Accept all</button>
              <button onClick={() => save({ analytics: false, preferences: false })} className="bg-ink text-white rounded-full px-4 py-2 text-sm font-semibold" data-testid="cookie-reject">Reject non-essential</button>
              {custom
                ? <button onClick={() => save(prefs)} className="border border-border rounded-full px-4 py-2 text-sm font-semibold" data-testid="cookie-save-prefs">Save choices</button>
                : <button onClick={() => setCustom(true)} className="border border-border rounded-full px-4 py-2 text-sm font-semibold" data-testid="cookie-customise-btn">Customise</button>}
            </div>
          </div>
          <button onClick={() => save({ analytics: false, preferences: false })} className="text-muted-foreground shrink-0" aria-label="Close" data-testid="cookie-close"><X size={18} /></button>
        </div>
      </div>
    </div>
  );
}
